module.exports = __webpack_public_path__ + "img/yuugi hoshiguma_sc2.98d8d9b7.png";